import { type AgentSessionResponse } from '@air/server-sdk';

type WorkspaceAgentSessionListCacheFields = {
  title?: string | null;
  status?: AgentSessionResponse['status'];
};

/**
 * Maps session fields onto sessions-list cache patch shape.
 * Pass only keys present in the PATCH / WSS delta — omitted keys are left unchanged in cache.
 * Add a branch here when the contract grows beyond title.
 */
export const buildWorkspaceAgentSessionListCachePatch = (
  updatedAt: string,
  fields: WorkspaceAgentSessionListCacheFields = {},
): Partial<AgentSessionResponse> => ({
  updatedAt,
  ...('title' in fields ? { title: fields.title ?? undefined } : {}),
  ...('status' in fields ? { status: fields.status } : {}),
});
